import { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import async from "async"
import { Tag } from "rsuite"
import { format, startOfMonth } from "date-fns"
import { Table, Spin, Tabs, Modal, Input } from 'antd';
import axiosService from "../../utils/axios.service";
import StorageService from "../../utils/storage.service";
import { notifications } from "../constant/Notify";
import { optionsSourceFromShow, optionsProvinceShow } from './constant/constant'
import ReactTooltip from "react-tooltip";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import HeaderDataSaleOnlineV2 from "./HeaderDataSaleOnlineV2"
import Edit from "./Edit";
import TabReport from "./TabReport";
import { CustomerOrderPopup } from "./OrderHistory";

import 'antd/dist/antd.min.css'
import styles from "./style.module.css"


const ListDataSaleOnline = () => {
    const [title, setTitle] = useState("")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [status, setStatus] = useState("Mess")
    const [hour, setHour] = useState('All')
    const [minute, setMinute] = useState('All')
    const [store, setStore] = useState(0)
    const [category, setCategory] = useState(0)
    const [sourceFrom, setSourceFrom] = useState(0)
    const [province, setProvince] = useState(0)

    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState([])
    const [keyword, setKeyword] = useState([])
    const [dataSaleOnline, setDataSaleOnline] = useState(null)
    const [dataEditCode, setDataEditCode] = useState(null)
    const [totalWelcome, setTotalWelcome] = useState(0)
    const [showEdit, setShowEdit] = useState(false)
    const [dataEdit, setDataEdit] = useState({})
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [listUser, setListUser] = useState([])
    const [aov, setAov] = useState([])
    const [selectUser, setSelectUser] = useState(0)
    const [dataDelete, setDataDelete] = useState(null)
    const [deleteDisplay, setDeleteDisplay] = useState(false)
    const [optionCategory, setOptionCategory] = useState([])
    const [dataPreOrder, setDataPreOrder] = useState(null)
    const [popupPreOrder, setPopupPreOrder] = useState(false)

    useEffect(() => {
        setTitle("Data sale online")
    }, [])

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }

    const handleCategory = (x) => {
        setCategory(x)
    }

    const handleProvince = (x) => {
        setProvince(x)
    }

    const fetchData = async (sD, eD, s) => {
        const { data } = await async.parallel({
            data: (cb) => {
                axiosService(`api/sale/online-v2/all?start=${sD}&end=${eD}&store_id=${store}&keyword=${keyword}&status=${status}&hour=${hour}&minute=${minute}&user_id=${selectUser}&category=${category}&sourceFrom=${sourceFrom}&province=${province}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            }
        })
        if (data.code === 200) {
            setLoading(false)

            const {list, total, aov} = data.data
            setTotalWelcome(total)
            let dataIt = list.map((item, index) => ({
                ...item,
                created_at: convertDate(item.mess_date_start),
                end_at: convertDate(item.online_date_end),
                province_name: optionsProvinceShow[item.province] ?? ''
            }))

            setTable([...dataIt])
            setAov([...aov])
        }
    }

    const getDataUser = async () => {
        let { data } = await axiosService(`api/users/store/1?role=5`, "GET")
        if (data.code === 200) {
            var optionUser = [{value: 0, label:"All"}]
            for (let item of data.data) {
                let row = {
                    value: item.id,
                    label: item.name
                }
                optionUser.push(row)
            }
            setListUser([...optionUser])
        }
    }

    const getDataCategory = async () => {
        let { data } = await axiosService(`api/category?type=1&product_type=2`, "GET")
        if (data.code == 200) {
            var option = []
            for (let item of data.data) {
                let row = {
                    value: item.id,
                    label: item.name,
                    product: item.product
                }
                option.push(row)
            }
            setOptionCategory([...option])
        }
    }

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store, status, hour, minute, sourceFrom)
        getDataUser()
        getDataCategory()
    }, [startDate, endDate, store, keyword, status, hour, minute, selectUser,category, sourceFrom, province])
    
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    function convertDate(data) {
        let res = ''
        let date = new Date(data)
        let book_hour = ("0" + date.getHours()).slice(-2),
            book_minute = ("0" + date.getMinutes()).slice(-2);
        if (data) {
            res = format(new Date(data), 'yyyy-MM-dd') + " " + [book_hour, book_minute].join(":")
        }
        return res;
    };

    const onChangeOrderCode = (e) => {
        setDataEditCode(e.target.value)
    }

    const clickDeleteLead = async (data) => {
        setDeleteDisplay(false)
        let res = await axiosService("api/sale/online-v2/delete/" + data.id, "POST", data)
        if (res.data.code == 200) {
            fetchData(startDate, endDate, store, status, hour, minute)
            notifications({
                type: "success",
                mess: "Xoa thành công",
            });
        } else {
            notifications({
                type: "error",
                mess: "Đã có lỗi xảy ra, vui lòng thử lại sau",
            }) 
        };
    }

    const saveEditOrderCode = async (data) => {
        if (dataEditCode && dataEditCode.length > 5 ) {
            let res = await axiosService("api/sale/online-v2/pre-order/" + data.id + '?order_code=' + dataEditCode, "POST", data)
            if (res.data.code == 200) {
                fetchData(startDate, endDate, store, status, hour, minute)
                setDataSaleOnline(null)
                notifications({
                    type: "success",
                    mess: "Tạo Pre order thành công",
                });
            } else {
                let mess = "Đã có lỗi xảy ra, vui lòng thử lại sau"
                if (res.data.code == 404 && res.data.message && res.data.message != '') mess = res.data.message
                
                notifications({
                    type: "error",
                    mess: mess,
                });
            }
        }
    }

    const onClickOrderCode = (data) => {
        setDataEditCode(data.order_code)
        setDataSaleOnline(data)
    }

    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const handleCreateDataSale = (data) => {

    }
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }
    const addLead = async (data) => {
        let res = await axiosService("api/sale/online-v2", "POST", data)
        if(res.data.code == 200) {
            notifications({
                type: "success",
                mess: "Tạo Lead thành công",
            });
            fetchData(startDate, endDate, store, status, hour, minute)
        } else {
            notifications({
                type: "error",
                mess: "Đã có lỗi xảy ra, vui lòng thử lại sau",
            });
        }
    }

    const headerChangeStatus = (e) => {
        setStatus(e)
    }

    const handleSourceFrom = (e) => {
        setSourceFrom(e)
    }

    const headerChangeHour = (e) => {
        setHour(e)
    }

    const headerChangeMinute = (e) => {
        setMinute(e)
    }

    const clickEditLead = (data) => {
        setDataEdit(data)
        setShowEdit(true)
    }

    const handleShowEdit = () => {
        setShowEdit(!showEdit)
    }

    const editLead = async (data) => {
        let res = await axiosService("api/sale/online-v2/update/" + dataEdit.id, "POST", data)
        if(res.data.code == 200) {
            fetchData(startDate, endDate, store, status, hour, minute)
            notifications({
                type: "success",
                mess: "Edit data thành công",
            });
        } else {
            notifications({
                type: "error",
                mess: "Đã có lỗi xảy ra, vui lòng thử lại sau",
            });
        }
    }

    const getDataOrder = async (listOrder) => {
        setLoading(true)
        let res = await axiosService("api/sale/online-v2/get-data-pre-order", "POST", {listOrder})
        if (res.data.code === 200) {
            setPopupPreOrder(true)
            setDataPreOrder([...res.data.data])
        }
        setLoading(false)
    }
    const syncDataPancake = async () => {
        let res = await axiosService("api/sale/online-v2/sync-pancake", "POST")
        // if(res?.data?.length > 0) {
        //     fetchData(startDate, endDate, store, status, hour, minute)
        //     notifications({
        //         type: "success",
        //         mess: `Cập nhật thành công ${res.data.length} Mess`,
        //     });
        // } else {
        //     notifications({
        //         type: "error",
        //         mess: "Đã có lỗi xảy ra, vui lòng thử lại sau",
        //     });
        // }
    }

    const columns = [
        {
            title: 'Loại data',
            dataIndex: 'status',
            render: (data) => {
                return (
                    <>
                        <p className={data == 'Lead' ? 'text1' : data == 'Pre order' ? 'text4' : data == 'Mess' ? 'text2' : "text8"}>{data}</p>
                    </>
                )
            },
        },
        {
            title: 'Ngày lên data',
            dataIndex: 'mess_date_start',
            align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="">{convertDate(data)}</p>
                )
            },
        },
        {
            title: 'Cơ sở',
            dataIndex: 'store_name',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Họ tên - SĐT',
            dataIndex: ['nick_name', 'customer_mobile'],
            align: "center",
            render: (text, record) => {
                return (
                    <>
                        <p className="text1">{record.nick_name}</p>
                        <p className="text1">{record.customer_mobile}</p>
                    </>
                )
            },
        },
        {
            title: 'Nhóm dịch vụ',
            dataIndex: 'onlineItem',
            align: "center",
            render: (text, record) => {
                return (
                    record.onlineItem.length > 0 ? 
                        record.onlineItem.length > 1 ?
                            <>
                                <p style={{cursor: "pointer", textDecoration: "underline"}} data-tip data-for={"category-" + record.id}>Nhiều nhóm</p>
                                <ReactTooltip className="tooltip-booking" place="bottom" type="dark" id={"category-" + record.id}>
                                    {record.onlineItem.map((item, key) => (
                                        <p style={{textAlign: "left"}} key={key}>- {item.category_product_name}</p>
                                    ))}
                                </ReactTooltip>
                            </>
                        :
                            <p className="text1">{record.onlineItem[0].category_product_name}</p>  
                    : ""
                      
                )
            },
        },
        {
            title: 'Dịch vụ',
            dataIndex: 'onlineItem',
            align: "center",
            render: (text, record) => {
                return (
                    record.onlineItem.length > 0 ? 
                        record.onlineItem.length > 1 ?
                            <>
                                <p style={{cursor: "pointer", textDecoration: "underline"}} data-tip data-for={"product-" + record.id}>Nhiều dịch vụ</p>
                                <ReactTooltip className="tooltip-booking" place="bottom" type="dark" id={"product-" + record.id}>
                                    {record.onlineItem.map((item, key) => (
                                        <p style={{textAlign: "left"}} key={key}>- {item.product_name}</p>
                                    ))}
                                </ReactTooltip>
                            </>
                        :
                            <p className="text1">{record.onlineItem[0].product_name}</p>  
                    : ""
                      
                )
            },
        },
        {
            title: 'Ngày chốt',
            width: 150,
            dataIndex: 'online_date_end',
            align: "center",
            render: (data) => {
                return (
                    <p className="text3">{convertDate(data)}</p>
                )
            },
        },
        {
            title: 'Đã thanh toán',
            dataIndex: 'paid_order',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Doanh số dự kiến',
            dataIndex: 'total_price',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Kênh',
            dataIndex: 'source_from',
            align: "center",
            render: (data) => {
                return (
                    <p className="text6">{optionsSourceFromShow[data]}</p>
                )
            },
        },
        {
            title: 'Tỉnh',
            dataIndex: 'province',
            align: "center",
            render: (data) => {
                return (
                    <p className="text6">{optionsProvinceShow[data]}</p>
                )
            },
        },
        {
            title: 'Tư vấn viên',
            dataIndex: 'sale_by_name',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Loại khách hàng',
            dataIndex: 'status_customer',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status_come',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data === 2 ? "Đã đến" : "Chưa đến"}</p>
                )
            },
        },
        {
            title: 'Mã hoá đơn',
            dataIndex: ['order_code', 'order_id', 'id'],
            align: "center",
            render:  (text, record) => {
                return (
                    
                        <div>
                            {record.order_code ? 
                               <>
                                    <p onClick={() => getDataOrder(record.order_code)} style={{textDecoration: "underline", cursor: "pointer"}} data-tip data-for={"order-" + record.id}>
                                        {(record.order_code && record.order_code.includes(',')) ? "Nhiều hóa đơn" : record.order_code}
                                    </p>
                                    <ReactTooltip className="tooltip-booking" place="bottom" type="dark" id={"order-" + record.id}>
                                        {record.order_code.split(',').map((item, key) => (
                                            <p style={{textAlign: "left"}} key={key}>- {item}</p>
                                        ))}
                                    </ReactTooltip>
                                </>
                            : null}
     
                            {["Lead", "Pre order"].includes(record.status) ?
                                <p className="text1" style={{cursor: 'pointer'}} onClick={() => onClickOrderCode(record)}>
                                    <span><i className="fas fa-edit"></i></span>
                                </p>
                            : null}
                        </div>
                        
                    
                )
            },
        },
        {
            title: 'Action',
            dataIndex: '',
            align: "center",
            render: (text, record) => {
                return (
                    <div className="button-container-list">
                        <div className={`${styles.buttonAction} ${styles.redButton}`}onClick={() => {setDataDelete(record); setDeleteDisplay(true)}}>Xóa</div>
                        <div className={styles.buttonAction} onClick={() => clickEditLead(record)}>Sửa</div>
                    </div>
                )
            },
        }
    ];

    const tabItems = [
        {
            key: '1',
            label: 'Bảng số liệu chi tiết',
            children: (
                <Table 
                    columns={columns} 
                    dataSource={table}
                    scroll={{ x: 1000 }}
                    rowKey={"id"}
                    bordered
                />
            ),
        },
        {
            key: '2',
            label: 'Thống kê',
            children: (
                <TabReport
                    table = {aov}
                    startDate={startDate}
                    endDate={endDate}
                    userId={1}
                    userName={'admin'}
                />
            ),
        },
    ];
    return (
        <div className={`container-fluid ${styles.background}`}>
            <HeaderDataSaleOnlineV2 startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                handleCreateDataSale={handleCreateDataSale}
                onChangeKeyword={onChangeKeyword}
                addLead={addLead}
                headerChangeStatus={headerChangeStatus}
                headerChangeHour={headerChangeHour}
                headerChangeMinute={headerChangeMinute}
                listUser={listUser}
                setSelectUser={setSelectUser}
                handleExportData={handleExportData}
                handleSourceFrom={handleSourceFrom}
                handleProvince={handleProvince}
                sortBy={0}
                title={title} type={"sales"}
                csvData={table} isExport={isExport}
                optionCategoryAll={optionCategory}
                header={
                    [
                        { label: 'Trạng thái', key: "status" },
                        { label: "Ngày lên data", key: "created_at" },
                        { label: "Cơ sở", key: "store_name" },
                        { label: "Nick name", key: `nick_name` },
                        { label: "Tên khách hàng", key: `customer_name` },
                        { label: "Số điện thoại", key: `customer_mobile` },
                        // { label: "Nhóm dịch vụ", key: `onlineItem_category_product_name` },
                        // { label: "Dịch vụ", key: `onlineItem_product_name` },
                        { label: "Ngày chốt", key: `end_at` },
                        { label: "Đã thanh toán", key: `paid_order` },
                        { label: "Doanh số dự kiến", key: `total_price` },
                        { label: "Nguồn", key: `source_from` },
                        { label: "Tỉnh", key: `province_name` },
                        { label: "Tư vấn viên", key: `sale_by_name` },
                        { label: "Loại khách hàng", key: `status_customer` },
                        { label: "Mã hoá đơn", key: `order_code` },
                    ]
                }
                userAdmin={userAdmin}
                handleCategory={handleCategory}
                syncDataPancake={syncDataPancake}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <Row>
                    <Col xs={12} md={8}>
                        <Row className="h-100">
                            <Col xs={12} md={3}>
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <span className={styles.textTag3}>Doanh số dự kiến: </span>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <span className={styles.textTag}> </span>
                                            <br />
                                            <br />
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag}>
                                                {convertCurrency(totalWelcome)}</span>
                                            <br />
                                        </div>
                                    </div>
                                </Tag>
                            </Col>

                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <Tabs defaultActiveKey="1" items={tabItems} />
                    </Col>
                </Row>
            </Spin>
            {dataDelete ?
                <Modal title={`Xóa ${dataDelete.status}`} open={deleteDisplay} onOk={() => clickDeleteLead(dataDelete)} onCancel={() => setDeleteDisplay(false)}>
                    <p>{`Xác nhận xóa data khách ${dataDelete.nick_name}`}</p>
                </Modal>
            : null}
            {dataSaleOnline ?
                <Modal title={`Tạo Pre Order`} open={dataSaleOnline ? true : false} onOk={() => saveEditOrderCode(dataSaleOnline)} onCancel={() => setDataSaleOnline(null)}>
                    <p>{`Nhập mã hóa đơn`}</p>
                    <Input onChange={onChangeOrderCode} type="text" value={dataEditCode} defaultValue={dataEditCode} />
                </Modal>
            : null}
            {showEdit ?
                <Edit show={showEdit} close={handleShowEdit} editLead={editLead} dataEdit={dataEdit} optionCategory={optionCategory} listUser={listUser}/>
            : null}
            {popupPreOrder ?
                <div className="admin-page customer">
                    <div className="admin-body">
                        <div className="dashboard-content">
                            <div className="wrapper">
                                <div className="fixed-column">
                                    <div className="order-popup">
                                        <div className="popup-cent">
                                            <div className="content-popup fadeInDown">
                                                {dataPreOrder && dataPreOrder.length >= 1 ?
                                                    <>
                                                        <Swiper
                                                            spaceBetween={10}
                                                            slidesPerView={1}
                                                            loop={dataPreOrder.length > 1}
                                                            navigation={{
                                                                clickable: true,
                                                                nextEl: ".swiper-button-next",
                                                                prevEl: ".swiper-button-prev"
                                                            }}
                                                            modules={[Navigation]}
                                                        >
                                                            {dataPreOrder.map((x,y) => {
                                                                return (
                                                                    <SwiperSlide key={y}>
                                                                        <CustomerOrderPopup orderDetail={x} />
                                                                    </SwiperSlide>
                                                                )
                                                            })}
                                                        </Swiper>
                                                        <div className={`swiper-button-prev`} style={{left: "-50px", zIndex: "9999"}}>
                                                            <svg className="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="#FF6513"></path></svg>
                                                        </div>
                                                        <div className="swiper-button-next" style={{right: "-50px", zIndex: "9999"}}>
                                                            <svg className="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="#FF6513"></path></svg>
                                                        </div>
                                                    </>
                                                :
                                                    <>
                                                        <div className="head-popup">
                                                            <div className="title">Chi tiết đơn hàng</div>
                                                            <div className="close" onClick={() => setPopupPreOrder(false)}>×</div>
                                                        </div>
                                                        <div className="body-popup">
                                                            <p>Không tìm thấy hóa đơn nào</p>
                                                        </div>
                                                    </>
                                                }
                                                <div className="bottom-popup">
                                                    <div className="button-container">
                                                        <div className="button-cent style3" onClick={() => setPopupPreOrder(false)}>
                                                            <span><i className="fas fa-times"></i></span>Đóng
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="overlay" onClick={() => setPopupPreOrder(false)}></div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            : null}
        </div>
    )
}
export default ListDataSaleOnline